import { render } from "./PartnerHeader.vue?vue&type=template&id=452d9032&scoped=true"
import script from "./PartnerHeader.vue?vue&type=script&lang=js"
export * from "./PartnerHeader.vue?vue&type=script&lang=js"

import "./PartnerHeader.vue?vue&type=style&index=0&id=452d9032&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-452d9032"]])

export default __exports__